import { checkPropTypes } from 'prop-types';
import React from 'react';

const Success = () => (
    <div className="daisy-maes">
        <div className="success-message">
            <header className="top">
                <img src="/images/logo.jpg" alt="Daisy Mae's Logo" />
            </header>
            <hr />
            <center>
                <br />
                <h2>Your order has been received!</h2>

                <p>Thanks for you support.</p>

                <p>If you have any questions please email us at daisymaebbq@gmail.com.</p>
            </center>
        </div>
    </div>
)

export default Success;


// WEBPACK FOOTER //
// ./src/components/Success.js